import React, { Component } from 'react';
import {Row} from 'antd'


class Routes extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
        <>
        <Row>
        </Row>
        </> 
        );
    }
}
 
export default Routes;